export default __webpack_public_path__ + "e31ce25.png";